import { LogArgument, PORTAL } from "da-pcc-frontend-shared-domain";

export const portal = PORTAL.CC;

export function logMe(arg: LogArgument){
    return { logModel: { body: JSON.stringify(arg) }};
}